import { render, staticRenderFns } from "./TxtToArray.vue?vue&type=template&id=073ca076&scoped=true"
import script from "./TxtToArray.vue?vue&type=script&lang=js"
export * from "./TxtToArray.vue?vue&type=script&lang=js"
import style0 from "./TxtToArray.vue?vue&type=style&index=0&id=073ca076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073ca076",
  null
  
)

export default component.exports